import { createContext, useState, useEffect, ReactNode } from 'react';
import { userBookingAxios } from 'APIs';
import { useSelector, useDispatch } from 'react-redux';
import {
  setSearchKeyword,
  clearSearchKeyword,
  setOffset,
} from './bookingsSlice';
import { uniq } from 'lodash';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

interface AllBookings {
  id: string;
  firstName: string;
  lastName: string;
  phone: string;
  address: string;
  city: string;
  region: string;
  startDate: string;
  requirement: string;
  createBooking: string;
  chef: string | null;
  status: string;
  meals: string;
  startTime: string;
}
interface bookingData {
  isLoading: boolean;
  status: number;
  error: boolean;
  data: AllBookings[];
  totalBooking: number; // Total number of booking
}
interface BookingsContextProps {
  bookingData: bookingData;
  loadMore: () => Promise<void>;
  handleSearchChange: (searchTerm: string) => void;
  searchKeyword?: string;
  handleClearSearch: () => void;
}
const BOOKING_DATA_MODAL = {
  isLoading: true,
  status: 0,
  error: false,
  data: [],
  totalBooking: 0,
};
const LIMIT = 15; // Set the limit for pagination

export const BookingsContext = createContext<BookingsContextProps | undefined>(
  undefined
);

export const BookingsProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const dispatch = useDispatch();
  const { searchKeyword, offset, filters } = useSelector(
    (state: any) => state.bookings
  );
  console.log('@@ searchKeyword from redux at context:', searchKeyword);
  const [bookingData, setBookingData] =
    useState<bookingData>(BOOKING_DATA_MODAL);
  const fetchedBookingCount = bookingData.data.length;
  console.log('@@ bookingData:', bookingData);
  console.log('@@ fetchedBookingCount:', fetchedBookingCount);

  const navigate = useNavigate();

  const hasFilterSelected =
    filters &&
    Object.keys(filters).some((key) => {
      const value = filters[key];
      if (Array.isArray(value)) {
        return value.length > 0;
      }
      return value !== '' && value !== null && value !== undefined;
    });
  
  const getUrl = () => {
    let url = `/booking/getAll?offset=${offset}&limit=${LIMIT}`;

    console.log('@@ hasFilterSelected:', hasFilterSelected);

    if (searchKeyword && searchKeyword.length) {
      url += `?search=${searchKeyword}`;
    }

    if (hasFilterSelected) {
      url += `&filter=${filters}`;
    }
    return url;
  };

  // all user details
  const fetchData =  async () => {
    console.log('userBookingAxios', userBookingAxios);
    const url = getUrl();
    try {
      const response = await userBookingAxios.get(url); // Adjust endpoint
      console.log('response,,,,,1111,,,,,,,,,,', response);
      const {
        data: { error, data },
        status,
      } = response;
      setBookingData({
        isLoading: false,
        status: status,
        error: error,
        data: data.bookings,
        totalBooking: data.totalBookings,
      });
    } catch (err) {
      console.log('err', err); 
      //setError(err.message);

      if (axios.isAxiosError(err)) {
        const status = err.response?.status;

        if (status === 401) {
          localStorage.clear();
          navigate('/');
          return;
        }

      } else {
        console.log('err', err);
      }

    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    if (!searchKeyword && !hasFilterSelected) {
      return;
    }
    fetchData();
  }, [searchKeyword, hasFilterSelected]);

   useEffect(() => {
    if(bookingData.data.length > offset){
      dispatch(setOffset({ offset: bookingData.data.length}));

    }
  }, [bookingData.data, offset]);

  const loadMore = async () => {
    if (offset === 0) return;
    const url = getUrl();
    console.log('loadMore called!!!');
    try {
      const response = await userBookingAxios.get(url);
      const {
        data: { error, data },
        status,
      } = response;
      setBookingData({
        ...bookingData,
        status: status,
        error: error,
        data: uniq([...bookingData.data, ...data.bookings]),
      });
    } catch (err) {
      console.log('loadMore error:', err);

      if(axios.isAxiosError(err)){
        const status = err.response?.status;

        if(status === 401){
          localStorage.clear();
          navigate('/');
          return;
        }
      }

    }
  };
  const handleSearchChange = (searchTerm: string) => {
    dispatch(setSearchKeyword({ searchKeyword: searchTerm }));
  };

  const handleClearSearch = () => {
    dispatch(clearSearchKeyword());
  };

  return (
    <BookingsContext.Provider
      value={{
        bookingData,
        loadMore, //,userDetail //,searchLogic, //fetchUsers
        handleSearchChange,
        searchKeyword,
        handleClearSearch,
      }}
    >
      {children}
    </BookingsContext.Provider>
  );
};
